interface MoveItem {
  itemtype: string | { S: string };
  [k: string]: unknown;
}

export function getButtonIsDisabled(
  selectedItems: MoveItem[],
  selectedDestination: { id: string } | 'root',
): boolean {
  const selectedItemsContainsFile = selectedItems.some((item) => {
    const type = typeof item.itemtype === 'string' ? item.itemtype : item.itemtype?.S;
    return type === 'resource';
  });
  return selectedItemsContainsFile && selectedDestination === 'root';
}
